<template>
  <div class="mini-select" :class="(framed) ? 'mini-select--framed' : ''">
    <select
      class="mini-select__element"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      @input="updateSelf($event.target.value)"
      @change="$emit('change', $event.target.value)"
      :style="`color: ${color}`"
    >
      <slot></slot>
    </select>
    <div :style="`border-top-color: ${color}`" class="mini-select__arrow"></div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  // props: ['value', 'type', 'label', 'placeholder', 'color', 'framed'],
  props: {
    value: {},
    type: {},
    label: {},
    placeholder: {},
    color: {},
    framed: {
      type: Boolean
    }
  },
  methods: {
    updateSelf (name) {
      this.$emit('input', name)
    }
  }
}
</script>

<style lang="scss" scoped>
.mini-select {
  @include alignedFlex();

  &--framed {
    padding: 2px 4px;
    border: 1px solid $danger;
    border-radius: 3px;
  }

  &__element {
    @include clickableText();
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: none;
    background: transparent;
    margin: 0 2px 0 0;

    &:focus {
      outline: 0;
    }
  }

  &__arrow {
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid $danger;
    border-radius: 8px;
  }
}
</style>
